import React from 'react';

interface IconEmailProps {
    iconClasses?: string;
}

const IconEmail: React.FC<IconEmailProps> = ({ iconClasses }) => {
    return (
        <svg
            width="17"
            height="14"
            viewBox="0 0 17 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-email ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <path
                d="M2.25 0.75H14.25C15.075 0.75 15.75 1.425 15.75 2.25V11.25C15.75 12.075 15.075 12.75 14.25 12.75H2.25C1.425 12.75 0.75 12.075 0.75 11.25V2.25C0.75 1.425 1.425 0.75 2.25 0.75Z"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path
                d="M15.75 2.25L8.25 7.5L0.75 2.25"
                stroke="currentColor"
                strokeWidth="1.5"
            />
        </svg>
    );
};

export default IconEmail;
